export default {
    methods: {
        exibirAvisoValidadeCertificadoDigital(dados) {
            if (!dados) return

            if (dados.aVencer) {
                if (dados.diasValidade === 0) {
                    this.showWarningNotification(`O certificado digital da integração com o ${dados.nomeIntegracao}
                        expira <strong>hoje</strong>.`)
                }
                else {
                    this.showWarningNotification(`O certificado digital da integração com o ${dados.nomeIntegracao}
                        expira em <strong>${dados.diasValidade} dia(s)</strong>,
                        com data de validade até <strong>${dados.dataValidade}</strong>.`)
                }

            }
            else if (dados.isVencido) {
                this.showWarningNotification(`O certificado digital da integração com o ${dados.nomeIntegracao} expirou
                    em <strong>${dados.dataValidade}</strong>.`)
            }
        }
    }
}